import { create } from "zustand";
import { persist } from "zustand/middleware";
import { useAccessStore } from "@/store/access.store";
import {
  authenticateCustomer,
  isSessionExpired,
} from "@/lib/mockAuth";

const useSessionStore = create()(
  persist(
    (set, get) => ({
      user: null,
      sessionExpiresAt: null,
      signIn: (email, password) => {
        const result = authenticateCustomer(email, password);
        if (!result.ok) {
          return result;
        }
        set({
          user: { ...result.user, moduleToggles: result.modules },
          sessionExpiresAt: result.expiresAt,
        });
        useAccessStore.getState().bindSessionAccess(
          result.user.role,
          result.user.companyIds,
          result.user.permissions,
          result.modules,
        );
        return { ok: true };
      },
      signInPreview: ({
        email,
        name,
        systemCustomerId,
        permissions,
        modules,
        companyIds,
      }) => {
        const scope = companyIds ?? useAccessStore.getState().allowedCompanyIds;
        set({
          user: {
            id: "usr-preview",
            name,
            email,
            role: "group_admin",
            systemCustomerId,
            isPlatformPreview: true,
            permissions: permissions ?? [],
            companyIds: scope,
            moduleToggles: modules,
          },
          sessionExpiresAt: Date.now() + 12 * 60 * 60 * 1000,
        });
        useAccessStore.getState().bindSessionAccess(
          "group_admin",
          scope,
          permissions ?? [],
          modules,
        );
      },
      signOut: () => set({ user: null, sessionExpiresAt: null }),
      ensureSessionValid: () => {
        const { sessionExpiresAt, user } = get();
        if (user && isSessionExpired(sessionExpiresAt)) {
          set({ user: null, sessionExpiresAt: null });
          return false;
        }
        return Boolean(user);
      },
    }),
    {
      name: "gps-erp-next-session",
      onRehydrateStorage: () => (state) => {
        if (!state?.user) return;
        const modules =
          state.user.moduleToggles ??
          useAccessStore.getState().entitlements;
        useAccessStore.getState().bindSessionAccess(
          state.user.role,
          state.user.companyIds ?? [],
          state.user.permissions ?? [],
          modules,
        );
      },
    },
  ),
);

export { useSessionStore };
